export const collegeLight = "#FFCB05";
export const collegeDark = "#00274C";